export default __webpack_public_path__ + "static/media/arrow-jump.14cb986e.svg";